import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-copy-link',
  templateUrl: './copy-link.component.html',
  styleUrls: ['./copy-link.component.scss']
})
export class CopyLinkComponent implements OnInit {
  @Input() link?: string;
  @ViewChild(Tooltip) tooltip!: Tooltip;

  constructor() { }

  ngOnInit(): void {
  }

  copyClicked(){
    if (!this.link) {
      return;
    }
    navigator.clipboard.writeText(this.link);
    this.tooltip?.activate();
  }

}
